<template>
  <div class="secondstep">
    <el-form :model="basicConfig" ref="ruleForm" label-width="auto">
      <!-- 基本信息 -->
      <basic-info-form ref="basic" v-model="basicConfig" :activity-data="activityData"
        :background-opacity="backgroundOpacity" :ids="ids" />
      <!-- 活动页设置 -->
      <activity-page-form v-model="activityConfig" :background-opacity="backgroundOpacity"
        :selectTemplate="selectTemplate" :templateJson="templateJson" />
      <!-- 商品加购 -->
      <goods-buy-form v-model="goodsBuy" :background-opacity="backgroundOpacity" :activity-data="activityData" />
      <!-- 分享设置 -->
      <share-settings v-model="shareSettings" :activity-data="activityData" :background-opacity="backgroundOpacity" />
      <!-- 活动规则 -->
      <activity-rules v-model="activityRule" :background-opacity="backgroundOpacity" :activityData="activityData"
        @onGenerateRule="generateRule" />
      <actInfoSetting :valueRow="valueRow" :activityData="activityData" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition"/>
      <!-- 保存并完成设置弹框 -->
      <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>
        <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
        <div slot="footer" class="dialog-footer">
          <el-button @click="joinBlackList = false">取 消</el-button>
          <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
        </div>
      </el-dialog>
    </el-form>
  </div>
</template>

<script>
import BasicInfoForm from './components/BasicInfoForm.vue'
import ActivityPageForm from './components/ActivityPageForm.vue'
import GoodsBuyForm from './components/GoodsBuyForm.vue'
import ShareSettings from './components/ShareSettings.vue'
import ActivityRules from './components/ActivityRules.vue'
import { saveBilletDoux, getBilletDouxDetail } from "@/api/paradiseAndTaskCommonController.js";

export default {
  name: 'BilletDoux',
  components: {
    BasicInfoForm,
    ActivityPageForm,
    GoodsBuyForm,
    ShareSettings,
    ActivityRules,
  },
  props: {
    itemId: "",
    // 选择的模板
    selectTemplate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    ids: '',
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isKeyActivity: 0,
      placementPosition: [],
      // 基本信息数据
      basicConfig: {
        activityName: "", // 活动名称
        activityStartTime: null, // 活动开始时间
        activityEndTime: null, // 活动结束时间
        actMember: "1", // 活动对象
        partner: ["-1"], // 会员等级
        peopleSelected: [], // 基本信息-指定人群
        plusObject: 0, // plus会员 0:不限 1:plus会员 2:非plus会员
        isCheckOpenCardTime: false, // 是否勾选入会时间
        openCardStartTime: '', // 入会开始时间
        openCardEndTime: '', // 入会结束时间
        condFollow: false, // 活动条件
        levelList: [], // 会员等级列表
      },
      // 活动页设置
      activityConfig: {
        activityTitle: "情书贺卡", // 活动主题
        activityDescription: "定制你的情书——大胆表白出来", // 活动说明
        wordColor: "#1A1A1A", // 活动文字颜色
        selfImage: this.selectTemplate.url, // 自定义背景图
        selfReceiveImage: this.selectTemplate.url3, // 自定义接收页背景图
        selectedTemplates: [], // 选择的模板
      },
      // 商品加购
      goodsBuy: {
        exposureSwitch: false, // 是否添加购商品
        itemListFor: [], // 加购商品列表
      },
      // 分享设置
      shareSettings: {
        shareTitle: "我分享了一个情书贺卡活动给你，快来看看吧！", // 分享标题
        shareIntroduce: "我在京东有新发现，绝对适合你，速来围观～", // 分享描述
        sharePic: "https://cdn-image.yucrm.cn//hd/images/13315956_98c29d9c6c2a45f5967159f05d7db917.png", // 分享图片
      },
      // 活动规则
      activityRule: '',
      templateId: '', // 模板id
      pointActivityId: '', // 活动id(修改的时候需要传递)
      params: {}, // 参数
      joinBlackList: false, // 保存并完成设置弹窗
      checked: false, // 是否勾选保持并完成设置弹窗
      valueRow: null,
      // 是否为草稿 
      isDraft: false,
      // 模板json
      templateJson: '',
      // 参数
      params: {},
    }
  },
  computed: {
  },
  mounted() {
    // 初始化数据
    this.setDefaultVaule();
    // 回显数据
    this.getDetail();
  },
  watch: {
    valueRow: {
      handler(val) {
        if (val) {
          this.$emit("changevalueRow", val);
        }
      },
    }
  },
  methods: {
    // 初始化数据
    setDefaultVaule() {
      // 设置默认时间
      this.setDefaultTime([this.$getDate(30, 10)[0], this.$getDate(30, 10)[1]]);
      // 设置模板id
      if (this.selectTemplate && this.selectTemplate.id) {
        this.templateId = this.selectTemplate.id;
      }
      // 设置 templateJson
      if (this.selectTemplate) {
        this.templateJson = JSON.stringify(this.selectTemplate);
      }

    },
    // 设置默认时间
    setDefaultTime(timeData) {
      // 设置默认时间
      this.basicConfig.activityStartTime = timeData[0];
      this.basicConfig.activityEndTime = timeData[1];
      // 计算活动持续时间
      this.$refs.basic.calculateDuration();
    },
    // 生成规则
    generateRule() {
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "";
      //活动时间
      if (this.basicConfig.activityStartTime && this.basicConfig.activityEndTime) {
        text1 =
          "活动时间：" + this.basicConfig.activityStartTime + "-" + this.basicConfig.activityEndTime;
      }
      // 活动对象
      let actMemberMap = {
        1: "不限",
        2: "指定身份",
        3: "指定人群",
      };
      text2 = "活动对象：" + actMemberMap[this.basicConfig.actMember] + '\n';
      if (this.basicConfig.actMember == "1") {
        text2 += "1.活动参与对象：不限\n"
      } else if (this.basicConfig.actMember == "2") {
        if (this.basicConfig.partner.includes("-1")) {
          text2 += "1.活动参与对象：不限\n"
        } else {
          let levelText = [];
          levelText = this.basicConfig.levelList.filter(item => this.basicConfig.partner.includes(item.value)).map(item => item.name)
          if (this.basicConfig.partner.includes('0')) {
            levelText.unshift("非会员");
          }
          text2 += "1.活动参与对象：" + levelText.splice(",") + '\n';
        }
      } else if (this.basicConfig.actMember == "3") {
        text2 += "1.活动参与对象：指定人群\n"
      }
      let plusMap = {
        0: "不限",
        1: "plus会员",
        2: "非plus会员",
      };
      text2 += "2.Plus会员身份：" + plusMap[this.basicConfig.plusObject] + '\n'
      text2 += "3.活动条件：" + (this.basicConfig.condFollow ? "关注店铺方可参与活动" : "不限")
      // 参与流程
      text3 = "参与流程：\n" +
        '1.制作方流程：进入首页点击“制作情书”进入加购礼物页，关联你所需同步情书购买的礼包，将会在送出情书时同步展示你的礼物图片，如无需选择商品可跳过加购直接进入情书制作页，确认情书内容无误，完成制作填写接收方手机号，接收方可通过手机号领取你的心意\n' +
        '2.情书内容:需编辑接收方昵称、情书内容、你的昵称，并录制1秒以上60秒以内的表白语言，可进行预览查看制作效果，可返回修改，完成并确认接收方手机号后，无法修改定制内容\n' +
        '3.接收方流程：通过制作方转化链接进入接收页面，并填写接收方手机号，获取情书内容；'
      // 注意事项
      text4 = "注意事项：\n" +
        '1.活动过程中，凡以不正当手段（如作弊领取、恶意套取、刷信誉、虚假交易、扰乱系统、实施网络攻击等）参与本次活动的用户，商家有权终止其参与活动，并取消其获奖资格（如奖品已发放，商家有权追回），如给商家造成损失的，商家将保留向违规用户继续追索的权利;\n' +
        '2.如遇不可抗力(包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整的、活动中存在大面积作弊行为、活动遭受严重网络攻击或因系统故障导致活动中奖名单大批量出错，活动不能正常进行的)，商家有权取消、修改或暂停本活动；\n' +
        '3.主办方不对参与者网络及活动的平台的稳定性及安全性负责，并不对因网络传输原因而导致参与者提交的信息错误或延迟承担任何责任。所有参与者完全自愿选择参加本次活动。\n' +
        '4.为遵守相关法律规定和监管要求，我们将对您输入的内容进行自动化检测。请确保您输入的内容不包含违法违规行为。\n'
      let Arr = [text1, text2, text3, text4];
      let prefixes = ['一、', '二、', '三、', '四、'];
      this.activityRule = '';
      Arr.forEach((item, index) => {
        if (item.length > 0) {
          this.activityRule += prefixes[index] + item + '\n';
        }
      });
      // 移除最后的换行符
      this.activityRule = this.activityRule.trim();
    },
    // 保存并完成设置
    saveAndFinish() {
      // 校验参数
      let flag = this.checkParams();
      if (!flag) {
        return;
      }
      // 设置参数
      this.setParams();
      this.joinBlackList = true;
    },
    // 校验参数
    checkParams() {
      this.params = {}
      // 活动名称校验
      if (!this.basicConfig.activityName) {
        this.$message.warning('请填写活动名称');
        return false;
      }
      // 活动时间校验
      if (!this.basicConfig.activityStartTime) {
        this.$message.warning('请选择活动开始时间');
        return false;
      }
      if (!this.basicConfig.activityEndTime) {
        this.$message.warning('请选择活动结束时间');
        return false;
      }
      // 活动对象校验
      if (this.basicConfig.actMember == "2") {
        // 入会时间校验
        if (this.basicConfig.isCheckOpenCardTime) {
          if (!this.basicConfig.openCardStartTime) {
            this.$message.warning('请选择入会开始时间');
            return false;
          }
          if (!this.basicConfig.openCardEndTime) {
            this.$message.warning('请选择入会结束时间');
            return false;
          }
        }
      } else if (this.basicConfig.actMember == "3") {
        if (this.basicConfig.peopleSelected.length == 0) {
          this.$message.warning('请选择指定人群');
          return false;
        }
      }
      // 活动主题校验
      if (!this.activityConfig.activityTitle) {
        this.$message.warning('请填写活动主题');
        return false;
      }
      // 自定义背景图校验
      if (!this.activityConfig.selfImage) {
        this.$message.warning('请上传自定义背景图');
        return false;
      }
      // 自定义接收页背景图校验
      if (!this.activityConfig.selfReceiveImage) {
        this.$message.warning('请上传自定义接收页背景图');
        return false;
      }
      // 情书模板校验
      if (this.activityConfig.selectedTemplates.length == 0) {
        this.$message.warning('请选择情书模板');
        return false;
      }
      // 商品加购校验
      if (this.goodsBuy.exposureSwitch) {
        if (this.goodsBuy.itemListFor.length == 0) {
          this.$message.warning('请选择加购商品');
          return false;
        }
      }
      // if(!this.useValidateMoreActSet({customerPaperwork: this.activityConfig})) {
      //   return false;
      // }
      // 分享标题校验
      if (!this.shareSettings.shareTitle) {
        this.$message.warning('请填写分享标题');
        return false;
      }
      // 分享简介校验
      if (!this.shareSettings.shareIntroduce) {
        this.$message.warning('请填写分享简介');
        return false;
      }
      // 分享图片校验
      if (!this.shareSettings.sharePic) {
        this.$message.warning('请上传分享图片');
        return false;
      }
      // 活动规则校验
      if (!this.activityRule) {
        this.$message.warning('请生成活动规则');
        return false;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return false
      }
      return true;
    },
    // 设置参数
    setParams() {
      let allowLevel = this.getAllowLevel() // 获取活动对象
      this.params = {
        activityName: this.basicConfig.activityName, // 活动名称
        startTime: this.basicConfig.activityStartTime, // 活动开始时间
        endTime: this.basicConfig.activityEndTime, // 活动结束时间
        allowLevel: allowLevel, // 活动对象 
        crowdIds: this.basicConfig.peopleSelected.join(","), // 指定人群
        condFollow: this.basicConfig.condFollow ? 1 : 0, // 活动条件
        ruleDTO: {
          activityTitle: this.activityConfig.activityTitle, // 活动主题
          activityDescription: this.activityConfig.activityDescription, // 活动说明
          textColor: this.activityConfig.wordColor, // 活动字体颜色
          customBackgroundImageUrl: this.activityConfig.selfImage, // 自定义背景图
          customReceivePageBackgroundImageUrl: this.activityConfig.selfReceiveImage, // 自定义接收页背景图
          letterTemplateIds: this.activityConfig.selectedTemplates, // 情书模板(最多五个)
          shareTitle: this.shareSettings.shareTitle, // 小程序分享标题
          shareIntroduce: this.shareSettings.shareIntroduce, // 小程序分享描述
          sharePic: this.shareSettings.sharePic, // 小程序分享图片
          isCheckOpenCardTime: this.basicConfig.isCheckOpenCardTime, // 是否勾选入会时间
          openCardStartTime: this.basicConfig.openCardStartTime, // 入会开始时间
          openCardEndTime: this.basicConfig.openCardEndTime, // 入会结束时间  
          plusObject: this.basicConfig.plusObject, // plus会员身份
          isAddProduct: this.goodsBuy.exposureSwitch ? 1 : 0, // 是否加购商品
          itemList: this.goodsBuy.itemListFor, // 加购商品列表
          customerPaperwork: JSON.stringify({shopNameType: this.activityConfig.shopNameType}), // 客户信息配置
        },
        templateId: this.templateId, // 模板id
        ruleDescription: this.activityRule, // 活动规则
        isKeyActivity: this.isKeyActivity, //是否重点活动
        placementPosition: this.placementPosition.join(','), //活动投放位置
      }
      if (allowLevel == '-1' || allowLevel == '99') { // 当指定活动对象为不限或指定人群时
        // 当指定活动对象为不限时，入会时间参数重置
        this.params.ruleDTO.isCheckOpenCardTime = false
        this.params.ruleDTO.openCardStartTime = ''
        this.params.ruleDTO.openCardEndTime = ''
      }
      console.log("--- this.params:---", this.params)
    },
    // 获取活动对象
    getAllowLevel() {
      // 因为接口没有专门的字段指定活动对象
      // 不限对象：-1 指定会员：不限对象:-1,0,1,2,3,4,5 特定会员：1,2,3 指定人群 99
      let allowLevel = ''
      if (this.basicConfig.actMember == 1) { // 不限
        allowLevel = '-1'
      } else if (this.basicConfig.actMember == 2) { // 指定会员
        if (this.basicConfig.partner.includes("-1")) {
          allowLevel = '-1,0,' + this.basicConfig.levelList.map(item => item.value).join(',')
        } else {
          allowLevel = this.basicConfig.partner.join(',')
        }
      } else { // 指定人群
        allowLevel = "99"
      }
      return allowLevel
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.basicConfig.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      // 对原有草稿进行编辑然后继续保存草稿
      if (this.isDraftEdit) {
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          // 设置参数
          this.setParams()
          this.saveDraftFun() // 保存为草稿
        })
      } else {
        // 保存新的草稿
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          // 设置参数
          this.setParams();
          this.saveDraftFun() // 保存为草稿
        })
      }
    },
    // 保存为草稿
    saveDraftFun() {
      this.params.status = 5;
      this.handleDialogCloseAnoth(); // 调用接口保存数据
    },
    // 确认保存活动
    async handleDialogCloseAnoth() {
      // 勾选了检查
      if (this.checked == true || this.isDraft) {
        // 如果为新建活动, 或者保存草稿, 或者编辑草稿
        if (this.ids == "" || this.isDraft || this.isDraftEdit) {
          // 草稿箱
          if (this.isDraft) {
            this.params.status = 5
          } else if (this.isDraftEdit) {
            // 草稿箱-创建任务
            delete this.params.status;
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            this.params.id = this.valueRow.id
          }
        } else {
          // 编辑活动
          this.params.pointActivityId = this.ids;
          // 复制活动
          if (this.activityData.isCopy) {
            delete this.params.pointActivityId
          }
        }
        console.log("--- this.params:---", this.params)
        // 创建/编辑活动
        saveBilletDoux(this.params).then((res) => {
          if (res && res.code == 1) {
            if (this.isDraft) {
              this.$message.success("保存成功！")
              this.$emit("saveDraftBack");
            } else {
              // 跳转到创建成功页面
              this.joinBlackList = false;
              this.$router.push({
                name: "throw",
                query: {
                  id: res.data.id,
                  activityType: res.data.activityType,
                },
              });
              this.$message.success(res.message);
            }
          } else {
            this.$message.error(res.message);
          }
        }).catch((res) => { })
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    // 获取活动详情
    getDetail() {
      if (this.ids != "") {
        console.log("--- this.ids:---", this.ids)
        let id = this.ids;
        this.valueRow = { id: id };
        getBilletDouxDetail(id).then(res => {
          let detail = res.data
          if (res && res.code == 1) { // 执行回显操作
            // 活动id回显
            this.pointActivityId = detail.id;
            // 活动名称回显
            this.basicConfig.activityName = detail.activityName;
            // 复制的时候不回显时间
            if (!this.activityData.isCopy) {
              // 活动开始时间回显
              this.basicConfig.activityStartTime = detail.startTime;
              // 活动结束时间回显
              this.basicConfig.activityEndTime = detail.endTime;
            }
            // 是否重点活动回显
            this.isKeyActivity = detail.isKeyActivity || 0;
            this.placementPosition = detail.placementPosition ? detail.placementPosition.split(',') : ["SHOP"];

            // 活动对象回显
            const all_Level = detail.allowLevel.split(',');
            if (all_Level.length === 1 && all_Level[0] === '-1') {
              // 不限对象
              this.basicConfig.actMember = '1';
              this.basicConfig.partner = ['-1'];
            } else if (all_Level.length === 1 && all_Level[0] === '99') {
              // 指定人群
              this.basicConfig.actMember = '3';
              this.basicConfig.peopleSelected = detail.crowdIds.split(',');
            } else {
              // 指定会员
              this.basicConfig.actMember = '2';
              // 检查是否包含全部会员
              if (all_Level.includes('-1')) {
                this.basicConfig.partner = ['-1'];
              } else {
                // 过滤出有效的会员等级
                const validLevels = all_Level;
                this.basicConfig.partner = validLevels.length > 0 ? validLevels : ['-1'];
              }
              // 判断有没有指定入会时间
              if (detail.ruleDto.isCheckOpenCardTime) {
                this.basicConfig.isCheckOpenCardTime = true;
                this.basicConfig.openCardStartTime = detail.ruleDto.openCardStartTime;
                this.basicConfig.openCardEndTime = detail.ruleDto.openCardEndTime;
              }
            }
            // Plus会员回显
            this.basicConfig.plusObject = detail.ruleDto.plusObject;
            // 活动条件回显
            if (detail.condFollow) {
              this.basicConfig.condFollow = true;
            } else {
              this.basicConfig.condFollow = false;
            }
            // 活动主题回显
            this.activityConfig.activityTitle = detail.ruleDto.activityTitle;
            // 活动说明回显
            this.activityConfig.activityDescription = detail.ruleDto.activityDescription;
            this.activityConfig.shopNameType = detail.ruleDto.customerPaperwork ? JSON.parse(detail.ruleDto.customerPaperwork).shopNameType : 0;
            // this.activityConfig.moreActSet = detail.ruleDto.customerPaperwork ? JSON.parse(detail.ruleDto.customerPaperwork).moreActSet : {
            //   isShowFloatWindow: 0, //是否显示活动浮窗：0-不显示，1-显示
            //   floatWindowImg: "", //活动浮窗图
            //   goShopSetting: 0, //活动浮窗跳转设置：0-不跳转，1-跳转
            //   goShopAppId: "", //活动浮窗跳转小程序ID
            //   goShopUrl: "",
            //   isShowBanner: 0, //是否显示活动banner：0-不显示，1-显示
            //   bannerList: [],
            // };
            // 活动文字颜色回显
            this.activityConfig.wordColor = detail.ruleDto.textColor;
            if (!this.activityData.isCopy) {
              // 自定义背景图回显(如果是复制则不回显)
              this.activityConfig.selfImage = detail.ruleDto.customBackgroundImageUrl;
              // 自定义接收页背景图回显(如果是复制则不回显)
              this.activityConfig.selfReceiveImage = detail.ruleDto.customReceivePageBackgroundImageUrl;
              // 情书模板回显(如果是复制则不回显)
              this.activityConfig.selectedTemplates = detail.ruleDto.letterTemplateIds;
            }
            // 模板id回显(如果是复制的时候不需要回显的templateId)
            if (this.selectTemplate && this.selectTemplate.id) {
              this.templateId = this.selectTemplate.id;
            } else {
              this.templateId = JSON.parse(detail.templateJson).id;
            }
            // 模板json设置
            if (this.selectTemplate && Object.keys(this.selectTemplate).length > 0) {
              this.templateJson = JSON.stringify(this.selectTemplate);
            } else {
              this.templateJson = detail.templateJson;
            }
            // 商品加购
            if (detail.ruleDto.isAddProduct) {
              this.goodsBuy.exposureSwitch = true;
              // 商品加购-商品回显
              this.goodsBuy.itemListFor = detail.ruleDto.itemList;
              if (this.goodsBuy.itemListFor) { // 设置属性代表商品都是已上架的
                this.goodsBuy.itemListFor.forEach((item) => { item.skuStatus = 1 })
              }
            } else {
              this.goodsBuy.exposureSwitch = false;
            }
            // 小程序分享标题回显
            this.shareSettings.shareTitle = detail.ruleDto.shareTitle;
            this.shareSettings.shareIntroduce = detail.ruleDto.shareIntroduce;
            this.shareSettings.sharePic = detail.ruleDto.sharePic;
            // 规则内容回显(复制的时候不回显规则)
            if (!this.activityData.isCopy) {
              this.activityRule = detail.ruleDescription;
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.secondstep {
  box-sizing: border-box;
  position: relative;
  padding: 0px 28px 1px 24px;
  margin-bottom: 29px;

  /deep/ .el-table .el-table__header-wrapper th .cell {
    text-align: center;
    font-weight: 500;
  }

  /deep/ .el-table .el-table__header-wrapper th {
    border-right: 1px solid #f0f0f0;

    &:last-child {
      border-right: none;
    }
  }

  /deep/ .el-table--enable-row-transition .el-table__body td {
    text-align: center;
    border-right: 1px solid #f0f0f0;

    &:last-child {
      border-right: none;
    }
  }
}
</style>